import React from 'react';
import { TitleButton } from './style';
import { TitleButtonFormSubmiteProps } from './Models';
import { FieldError } from 'react-hook-form';

type Props = {
    textColor?: string;
    title?: string | Partial<FieldError> ;
    title2?: string | Partial<FieldError> ;
};

const Text: React.FC<TitleButtonFormSubmiteProps & Props> = ({
    onClick,
    textColor,
    fontSize,
    textAlign,
    fontFamily,
    fontWeight,
    type,
    textDecoration,
    title,
    title2,
    testID,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    cursor,
    width,
    firstSpan,
    secondSpan,
    padding,
    italic = false
})=> {
    return (
        <>
            <TitleButton
                onClick={() => { onClick && onClick(); }}
                testID={testID}
                color={textColor}
                textDecoration={textDecoration}
                type={type}
                fontSize={fontSize}
                textAlign={textAlign}
                fontFamily={fontFamily}
                fontWeight={fontWeight}
                marginLeft={marginLeft}
                marginRight={marginRight}
                marginTop={marginTop}
                marginBottom={marginBottom}
                cursor={cursor}
                width={width}
                padding={padding}
                italic={italic}
            >
                {(firstSpan || secondSpan) ? (
                    <>
                        {title2 && (
                            <>
                                {title} <span style={{fontWeight: 700}}>{firstSpan}</span> {title2} <span style={{fontWeight: 700}}>{secondSpan}</span>
                            </>
                        ) || (
                            <>
                                <span style={{fontWeight: 700}}>{firstSpan}</span> {title} <span style={{fontWeight: 700}}>{secondSpan}</span>
                            </>
                        )}
                    </>
                ) : (
                    title
                )}
            </TitleButton>
        
        </>
    );
};

export default Text;